// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* training-legacy.css — svuotato: gli stili dell'allenamento sono migrati in
   src/pages/TrainingLive.css, Trainings.css, TrainingDetail.css,
   TrainingShared.css e src/components/telemetry/TrainingPanel.css. */
`, "",{"version":3,"sources":["webpack://./src/styles/legacy/training-legacy.css"],"names":[],"mappings":"AAAA;;qEAEqE","sourcesContent":["/* training-legacy.css — svuotato: gli stili dell'allenamento sono migrati in\n   src/pages/TrainingLive.css, Trainings.css, TrainingDetail.css,\n   TrainingShared.css e src/components/telemetry/TrainingPanel.css. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
